/* theme.js — Seelchen World
   Pro Feature ein IIFE-Block mit Kommentar-Header. Alle Blöcke sind defensiv
   (Guards), damit nichts crasht, wenn ein Element auf einer Seite fehlt. */

// --- Feature: MailerLite Newsletter-Anmeldung ---
window.ml_webform_success_45490324 = function () {
  document.querySelectorAll('.ml-subscribe-form-45490324').forEach(function (container) {
    var form = container.querySelector('.row-form');
    var success = container.querySelector('.row-success');

    if (form) form.hidden = true;
    if (success) success.hidden = false;
  });
};

// --- Feature: Announcement-Leiste schließen und Fixed-Header nachführen ---
(function () {
  var root = document.documentElement;
  var bar = document.querySelector('[data-announcement-bar]');
  var dismissalStorageKey = 'seelchen:announcement-dismissed';
  var ticking = false;

  function setOffsets(height, visibleHeight) {
    root.style.setProperty('--announcement-bar-height', height + 'px');
    root.style.setProperty('--announcement-bar-visible-height', visibleHeight + 'px');
  }

  function update() {
    ticking = false;
    if (!bar || bar.hidden) {
      setOffsets(0, 0);
      return;
    }

    var height = bar.offsetHeight;
    var visibleHeight = Math.max(0, Math.min(height, bar.getBoundingClientRect().bottom));
    setOffsets(height, visibleHeight);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  if (!bar) {
    setOffsets(0, 0);
    return;
  }

  var dismissButton = bar.querySelector('[data-announcement-dismiss]');
  if (dismissButton) {
    dismissButton.addEventListener('click', function () {
      bar.hidden = true;
      if (!(window.Shopify && window.Shopify.designMode)) {
        try {
          window.sessionStorage.setItem(dismissalStorageKey, '1');
        } catch (error) {}
      }
      update();
    });
  }

  update();
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  if (typeof window.ResizeObserver !== 'undefined') {
    new window.ResizeObserver(requestUpdate).observe(bar);
  }
})();

(function () {
  if (!document.querySelector('.ml-subscribe-form-45490324')) return;
  if (typeof window.fetch !== 'function') return;

  window.fetch('https://assets.mailerlite.com/jsonp/2588599/forms/197505899327129542/takel')
    .catch(function () {});
})();

// --- Feature: Newsletter beim Scrollen einfahren und am Ziel andocken ---
(function () {
  var anchors = document.querySelectorAll('[data-newsletter-anchor]');
  if (!anchors.length) return;

  var mobileFilterBar = document.querySelector('.home-tiles__filter-bar');
  var tilesGrid = document.querySelector('.home-tiles__grid');
  var dismissalStorageKey = 'seelchen:newsletter-dismissed';
  var ticking = false;

  function wasDismissedInTab() {
    try {
      return window.sessionStorage.getItem(dismissalStorageKey) === '1';
    } catch (e) {
      return false;
    }
  }

  function rememberDismissal() {
    try {
      window.sessionStorage.setItem(dismissalStorageKey, '1');
    } catch (e) {
      /* Ohne Session Storage gilt die Auswahl nur bis zum Seitenwechsel. */
    }
  }

  function triggerY() {
    return Math.min(360, window.innerHeight * 0.45);
  }

  function fixedBottomGap() {
    if (window.innerWidth <= 950 && mobileFilterBar) {
      return mobileFilterBar.getBoundingClientRect().height + 15;
    }

    return 15;
  }

  function fixedTop(newsletter) {
    return Math.max(96, window.innerHeight - newsletter.offsetHeight - fixedBottomGap());
  }

  function resetFixedStyles(newsletter) {
    newsletter.style.top = '';
    newsletter.style.left = '';
    newsletter.style.width = '';
  }

  function updateNewsletter(anchor) {
    var newsletter = anchor.querySelector('.newsletter-signup');
    if (!newsletter) return;

    /* Nach dem Schließen bleibt das Formular dauerhaft an seinem natürlichen
       Platz im Footer. Es wird weder weiter fixed positioniert noch bei einem
       erneuten Scrollen ein- oder ausgefahren. */
    if (anchor.hasAttribute('data-newsletter-dismissed')) {
      newsletter.classList.remove('is-floating', 'is-visible');
      newsletter.classList.add('is-docked');
      resetFixedStyles(newsletter);
      return;
    }

    var anchorRect = anchor.getBoundingClientRect();
    var targetTop = fixedTop(newsletter);
    var shouldDock = anchorRect.top <= targetTop;
    var shouldFloat = !shouldDock;
    var shouldShow = window.scrollY >= triggerY();

    newsletter.classList.toggle('is-floating', shouldFloat);
    newsletter.classList.toggle('is-docked', shouldDock);
    newsletter.classList.toggle('is-visible', shouldShow && shouldFloat);

    if (shouldFloat) {
      newsletter.style.top = targetTop + 'px';
      newsletter.style.left = anchorRect.left + 'px';
      newsletter.style.width = anchorRect.width + 'px';
    } else {
      resetFixedStyles(newsletter);
    }
  }

  function update() {
    ticking = false;
    anchors.forEach(updateNewsletter);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  anchors.forEach(function (anchor) {
    if (wasDismissedInTab()) anchor.setAttribute('data-newsletter-dismissed', '');

    var newsletter = anchor.querySelector('.newsletter-signup');
    if (newsletter) newsletter.classList.add('newsletter-signup--scroll-ready');

    var dismissButton = anchor.querySelector('[data-newsletter-dismiss]');
    if (dismissButton) {
      dismissButton.addEventListener('click', function () {
        anchor.setAttribute('data-newsletter-dismissed', '');
        rememberDismissal();
        requestUpdate();
      });
    }
  });

  update();

  window.requestAnimationFrame(function () {
    anchors.forEach(function (anchor) {
      var newsletter = anchor.querySelector('.newsletter-signup');
      if (newsletter) newsletter.classList.add('newsletter-signup--scroll-active');
    });
  });

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  if (typeof window.ResizeObserver !== 'undefined') {
    var layoutObserver = new window.ResizeObserver(requestUpdate);
    if (mobileFilterBar) layoutObserver.observe(mobileFilterBar);
    if (tilesGrid) layoutObserver.observe(tilesGrid);
  }
})();

// --- Feature: Development-Grid mit G ein-/ausblenden ---
(function () {
  var grid = document.querySelector('[data-layout-grid]');
  if (!grid) return;

  document.addEventListener('keydown', function (event) {
    var target = event.target;
    var isEditing = target && (
      target.isContentEditable ||
      /^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName)
    );

    if (
      isEditing ||
      event.defaultPrevented ||
      event.repeat ||
      event.altKey ||
      event.ctrlKey ||
      event.metaKey ||
      event.key.toLowerCase() !== 'g'
    ) return;

    grid.hidden = !grid.hidden;
  });
})();

// --- Feature: Stumme Autoplay-Videos zuverlässig starten ---
(function () {
  function play(video) {
    if (!video || !video.matches('video[autoplay]')) return;

    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.controls = false;

    var playback = video.play();
    if (playback && typeof playback.catch === 'function') {
      playback.catch(function () {});
    }
  }

  function playAll(root) {
    if (!root) return;
    if (root.matches && root.matches('video[autoplay]')) play(root);
    if (!root.querySelectorAll) return;
    root.querySelectorAll('video[autoplay]').forEach(play);
  }

  function start() {
    playAll(document);

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(playAll);
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) playAll(document);
  });
  window.addEventListener('pageshow', function () { playAll(document); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

// --- Feature: Eszett in Ramdassy-Texten vereinheitlichen ---
(function () {
  var SCRIPT_FONT = 'Ramdassy';

  function replaceEszett(textNode) {
    if (!textNode || !/[ßẞ]/.test(textNode.nodeValue)) return;

    var parent = textNode.parentElement;
    if (!parent || window.getComputedStyle(parent).fontFamily.indexOf(SCRIPT_FONT) === -1) return;

    textNode.nodeValue = textNode.nodeValue
      .replace(/ß/g, 'ss')
      .replace(/ẞ/g, 'SS');
  }

  function normalize(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      replaceEszett(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE) return;

    var elements = [root].concat(Array.prototype.slice.call(root.querySelectorAll('*')));
    elements.forEach(function (element) {
      Array.prototype.slice.call(element.childNodes).forEach(function (child) {
        if (child.nodeType === Node.TEXT_NODE) replaceEszett(child);
      });
    });
  }

  function start() {
    normalize(document.body);

    if (typeof MutationObserver === 'undefined') return;

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          replaceEszett(mutation.target);
          return;
        }

        Array.prototype.slice.call(mutation.addedNodes).forEach(normalize);
      });
    }).observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

// --- Feature: Splashscreen (nur Home) ---
(function () {
  var splash = document.querySelector('[data-splash]');
  if (!splash) return;

  var storageKey = 'seelchen:intro-seen';
  var alreadySeen = false;
  try {
    alreadySeen = window.sessionStorage.getItem(storageKey) === '1';
  } catch (e) {
    /* Session Storage kann in restriktiven Browsermodi deaktiviert sein. */
  }

  if (alreadySeen) {
    splash.remove();
    return;
  }

  try {
    window.sessionStorage.setItem(storageKey, '1');
  } catch (e) {
    /* Ohne Storage bleibt das bisherige Verhalten als sicherer Fallback. */
  }

  splash.hidden = false;
  document.body.classList.add('splash-active');

  var done = false;
  var timer = null;

  function close() {
    if (done) return;
    done = true;
    window.removeEventListener('scroll', onScroll);
    document.body.classList.remove('splash-active');
    splash.classList.add('splash--fade');
    window.setTimeout(function () {
      splash.remove();
    }, 700); /* etwas länger als die opacity-transition in splash.css */
  }

  function onScroll() {
    window.clearTimeout(timer);
    close();
  }

  timer = window.setTimeout(close, 2500);
  window.addEventListener('scroll', onScroll, { passive: true });

  splash.addEventListener('click', function () {
    window.clearTimeout(timer);
    close();
  });

  splash.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      window.clearTimeout(timer);
      close();
    }
  });
})();

// --- Feature: Menü-Overlay ---
(function () {
  var overlay = document.querySelector('[data-menu-overlay], #menu-overlay');
  var openBtn = document.querySelector('[data-menu-toggle]');
  if (!overlay || !openBtn) return;

  var closeBtn = overlay.querySelector('[data-menu-close]');
  var isOpen = false;
  var closeTimer = null;
  /* etwas länger als die längste CSS-Transition in header.css (.55s Slide) */
  var DURATION = 600;

  function setMenuOpen() {
    document.documentElement.classList.add('menu-open');
    document.body.classList.add('menu-open');
  }

  function clearMenuOpen() {
    document.body.classList.remove('menu-open');
    document.documentElement.classList.remove('menu-open');
  }

  function open() {
    window.clearTimeout(closeTimer);
    isOpen = true;
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    /* doppelter rAF: Ausgangszustand (translateX(102%) / opacity 0) erst
       painten lassen, dann .is-open setzen — sonst läuft die Transition nicht */
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        overlay.classList.add('is-open');
      });
    });
    setMenuOpen();
    openBtn.setAttribute('aria-expanded', 'true');
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    openBtn.setAttribute('aria-expanded', 'false');
    /* menu-open erst nach der Slide-/Fade-Animation entfernen — sonst fällt
       der Header (Desktop z-index 120) sofort unter das Overlay und das
       rausgleitende Menü-Band überdeckt kurz das MENU-Icon. */
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      clearMenuOpen();
      overlay.hidden = true;
    }, DURATION);
  }

  openBtn.addEventListener('click', function () {
    if (isOpen) close(); else open();
  });
  if (closeBtn) closeBtn.addEventListener('click', close);

  /* Klick auf die freie Fläche unter/neben dem Menü-Band schließt (Desktop) */
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !overlay.hidden) close();
  });
})();

// --- Feature: Warenkorb-Zähler im Header ---
(function () {
  var indicators = document.querySelectorAll('[data-cart-indicator]');
  if (!indicators.length) return;

  var graphics = document.querySelectorAll('[data-cart-graphic]');
  var buttons = document.querySelectorAll('[data-cart-button]');
  var storageKey = 'seelchen-cart-count';
  var count = 0;

  try {
    count = Math.max(0, parseInt(window.localStorage.getItem(storageKey), 10) || 0);
  } catch (error) {
    count = 0;
  }

  function displayCount(value) {
    return value > 99 ? '99+' : String(value);
  }

  function update(announce) {
    var graphicIndex = Math.min(8, Math.max(0, Math.floor(count)));

    graphics.forEach(function (graphic) {
      var source = graphic.getAttribute('data-cart-graphic-' + graphicIndex);
      if (source && graphic.getAttribute('src') !== source) {
        graphic.setAttribute('src', source);
      }
    });

    indicators.forEach(function (indicator) {
      var badge = indicator.querySelector('[data-cart-count]');
      var status = indicator.querySelector('[data-cart-status]');

      if (badge) {
        badge.textContent = displayCount(count);
        badge.hidden = count < 1;
        badge.setAttribute('aria-hidden', count < 1 ? 'true' : 'false');
      }

      if (status) {
        if (count < 1) {
          status.textContent = 'Cart is empty';
        } else {
          status.textContent = count + (count === 1 ? ' item in cart' : ' items in cart');
        }
        if (!announce) status.setAttribute('aria-live', 'off');
      }
    });
  }

  function addProduct() {
    count += 1;
    try {
      window.localStorage.setItem(storageKey, String(count));
    } catch (error) {
      /* Der Zähler funktioniert für die aktuelle Seite auch ohne Storage. */
    }

    indicators.forEach(function (indicator) {
      var status = indicator.querySelector('[data-cart-status]');
      if (status) status.setAttribute('aria-live', 'polite');
    });
    update(true);
  }

  buttons.forEach(function (button) {
    var form = button.closest('[data-product-form]');
    var variantInput = form && form.querySelector('input[name="id"]');
    if (!variantInput || !variantInput.value) {
      button.addEventListener('click', addProduct);
    }
  });

  document.addEventListener('seelchen:cart-updated', function (event) {
    count = Math.max(0, Number(event.detail && event.detail.count) || 0);
    update(true);
  });

  if (window.Shopify && window.Shopify.routes) {
    fetch((window.Shopify.routes.root || '/') + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        count = cart.item_count;
        update(false);
      })
      .catch(function () {
        /* Der lokale Preview hat keinen Shopify-Warenkorb. */
      });
  }

  update(false);
})();

// --- Feature: Scroll-Verhalten ---
/* Mobile: Die feste 71px-Leiste folgt auf allen Seiten der Scrollrichtung.
   Desktop: Home/Shop kennen weiterhin nur ganz oben oder gescrollt; die
   übrigen Seiten behalten ihre Backscroll-Menüleiste. */
(function () {
  var body = document.body;
  if (!body) return;

  var lastY = window.scrollY || window.pageYOffset || 0;
  var THRESHOLD = 120; /* Header-Höhe: erst danach zwischen den Zuständen wechseln */
  var TOP_ZONE = 10;
  var PHONE_MEDIA_QUERY = '(max-width: 950px)';

  function update() {
    var y = window.scrollY || window.pageYOffset || 0;
    var isTilePage = body.classList.contains('page-home') || body.classList.contains('page-shop');
    var isMobile = window.matchMedia(PHONE_MEDIA_QUERY).matches;

    if (isMobile) {
      if (y <= TOP_ZONE) {
        body.classList.remove('scrolled-down', 'scrolled-up');
      } else if (body.classList.contains('menu-open')) {
        body.classList.add('scrolled-up');
        body.classList.remove('scrolled-down');
      } else if (y > lastY && y > 71) {
        body.classList.add('scrolled-down');
        body.classList.remove('scrolled-up');
      } else if (y < lastY) {
        body.classList.add('scrolled-up');
        body.classList.remove('scrolled-down');
      }

      lastY = y;
      return;
    }

    if (isTilePage) {
      body.classList.toggle('scrolled-down', y > TOP_ZONE);
      body.classList.remove('scrolled-up');
      lastY = y;
      return;
    }

    if (y <= TOP_ZONE) {
      body.classList.remove('scrolled-down', 'scrolled-up');
    } else if (y > THRESHOLD &&
               !body.classList.contains('scrolled-down') &&
               !body.classList.contains('scrolled-up')) {
      /* Auch einen beim Reload wiederhergestellten Scrollstand markieren. */
      body.classList.add('scrolled-down');
    } else if (y > lastY && y > THRESHOLD) {
      body.classList.add('scrolled-down');
      body.classList.remove('scrolled-up');
    } else if (y < lastY) {
      body.classList.add('scrolled-up');
      body.classList.remove('scrolled-down');
    }

    lastY = y;
  }

  window.addEventListener('scroll', update, { passive: true });
  update();
})();

// --- Feature: Home-Inhalt reihenweise einfaden ---
/* Header, Filter, komplette Kacheln, Load-more und Home-Teaser werden anhand
   ihrer gerenderten Position in Reihen gruppiert. Packery setzt zuerst die
   endgültigen Positionen; danach läuft ausschließlich Opacity. Der Footer
   bleibt außen vor. */
(function () {
  var body = document.body;
  var grid = document.querySelector('.home-tiles__grid');
  if (!body || !body.classList.contains('page-home') || !grid) {
    if (body) body.classList.remove('intro-pending');
    return;
  }
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    body.classList.remove('intro-pending');
    body.classList.add('intro-done');
    return;
  }

  var SELECTORS = [
    '.announcement-bar',
    '.site-header__stamps',
    '.site-header__menu-toggle',
    '.site-header__logo',
    '.site-header__mobile-logo',
    '.site-header__cart',
    '.home-tiles__filter-item',
    '.home-tiles__subfilters',
    '.home-tiles__grid > .tile-card',
    '.home-tiles__load-more',
    '.home-tiles__about'
  ];

  function collect() {
    var seen = new Set();
    var items = [];
    SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        if (seen.has(el) || el.hasAttribute('hidden')) return;
        seen.add(el);
        if (el.classList.contains('tile-card--hidden') ||
            el.classList.contains('tile-card--paged-out')) return;
        var style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') return;
        var rect = el.getBoundingClientRect();
        if (rect.width < 2 || rect.height < 2) return;
        items.push({ el: el, top: rect.top, left: rect.left });
      });
    });
    items.sort(function (a, b) { return a.top - b.top || a.left - b.left; });
    return items;
  }

  function groupByRenderedRow(items) {
    var rows = [];
    items.forEach(function (item) {
      var row = rows[rows.length - 1];
      if (!row || Math.abs(item.top - row.top) > 20) {
        row = { top: item.top, items: [] };
        rows.push(row);
      }
      row.items.push(item);
    });
    return rows;
  }

  function run() {
    var items = collect();
    if (!items.length) {
      body.classList.remove('intro-pending');
      body.classList.add('intro-done');
      return;
    }

    body.classList.add('intro-armed');
    var rows = groupByRenderedRow(items);

    var ROW_STAGGER_MS = 120;
    var FADE_MS = 550;
    var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

    items.forEach(function (item) {
      item.el.style.transition = 'none';
      item.el.style.opacity = '0';
    });
    body.classList.remove('intro-pending');
    void body.offsetHeight;
    window.requestAnimationFrame(function () {
      rows.forEach(function (row, rowIndex) {
        row.items.forEach(function (item) {
          item.el.style.transition = 'opacity ' + FADE_MS + 'ms ' + EASE;
          item.el.style.transitionDelay = rowIndex * ROW_STAGGER_MS + 'ms';
          item.el.style.opacity = '1';
        });
      });
    });

    var maxDelay = (rows.length - 1) * ROW_STAGGER_MS;
    window.setTimeout(function () {
      items.forEach(function (item) {
        item.el.style.transition = '';
        item.el.style.transitionDelay = '';
        item.el.style.opacity = '';
      });
      body.classList.remove('intro-armed');
      body.classList.add('intro-done');
    }, maxDelay + FADE_MS + 100);
  }

  function afterPackery(cb) {
    if (grid.getAttribute('data-packery-ready') === '1') {
      cb();
      return;
    }
    document.addEventListener('home:packery-ready', cb, { once: true });
  }

  function start() {
    afterPackery(function () {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(run);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

// --- Feature: Home-Teaser-Wörter auf Scroll ---
/* Footer und About sind bewusst ausgenommen; About fadet minimal per CSS. */
(function () {
  var WORD_STAGGER_MS = 55;
  var CHAR_STAGGER_MS = 12; /* schneller Buchstaben-Cascade */
  var WORD_DURATION_MS = 700;
  var CHAR_DURATION_MS = 380;
  var WORD_EASE = 'cubic-bezier(0.25, 0.1, 0.25, 1)';

  function wordTransition(durationMs) {
    return (
      'opacity ' + durationMs + 'ms ' + WORD_EASE + ',' +
      ' transform ' + durationMs + 'ms ' + WORD_EASE
    );
  }

  function wordStaggerDelayMs(index, length) {
    if (length <= 1) return 0;
    return (index / (length - 1)) * WORD_STAGGER_MS * (length - 1);
  }

  function lineUnitDelayMs(indexInLine, stepMs) {
    return indexInLine * stepMs;
  }

  function splitWords(el) {
    if (el.getAttribute('data-words-split') === '1') {
      return Array.prototype.slice.call(el.querySelectorAll('.slide-up-word'));
    }
    var raw = el.textContent || '';
    el.textContent = '';
    var words = [];
    var parts = raw.split(/(\s+)/);
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      if (!part) continue;
      if (/^\s+$/.test(part)) {
        el.appendChild(document.createTextNode(part));
        continue;
      }
      var span = document.createElement('span');
      span.className = 'slide-up-word';
      span.textContent = part;
      el.appendChild(span);
      words.push(span);
    }
    el.setAttribute('data-words-split', '1');
    return words;
  }

  function splitChars(el) {
    if (el.getAttribute('data-chars-split') === '1') {
      return Array.prototype.slice.call(el.querySelectorAll('.slide-up-char'));
    }
    var raw = el.textContent || '';
    el.textContent = '';
    var chars = [];
    var i;
    for (i = 0; i < raw.length; i++) {
      var ch = raw[i];
      if (/\s/.test(ch)) {
        el.appendChild(document.createTextNode(ch));
        continue;
      }
      var span = document.createElement('span');
      span.className = 'slide-up-char';
      span.textContent = ch;
      el.appendChild(span);
      chars.push(span);
    }
    el.setAttribute('data-chars-split', '1');
    return chars;
  }

  function groupByVisualLine(units) {
    var lines = [];
    var curTop = null;
    var line = [];
    var i;
    for (i = 0; i < units.length; i++) {
      var top = Math.round(units[i].getBoundingClientRect().top);
      if (curTop === null || Math.abs(top - curTop) > 3) {
        if (line.length) lines.push(line);
        line = [units[i]];
        curTop = top;
      } else {
        line.push(units[i]);
      }
    }
    if (line.length) lines.push(line);
    return lines;
  }

  /* opts:
     textSelector / mediaSelector
     unit: 'words' (default) | 'chars'
     direction: 'up' (default) | 'left'
     parallelLines: Delay = Index in der Zeile (alle Zeilen ab t=0)
     immediate: sofort spielen
     onTimeline: function(totalMs) — nach Start, mit Gesamtdauer */
  function initSlideUpReveal(root, opts) {
    if (!root) return;
    opts = opts || {};
    var direction = opts.direction || 'up';
    var unit = opts.unit || 'words';
    var lineStep = unit === 'chars' ? CHAR_STAGGER_MS : WORD_STAGGER_MS;
    var unitDuration = unit === 'chars' ? CHAR_DURATION_MS : WORD_DURATION_MS;
    var transition = wordTransition(unitDuration);
    var from =
      direction === 'left' ? 'translateX(-0.35em)' : 'translateY(0.5em)';
    var to = 'translate(0, 0)';

    var items = [];

    if (opts.mediaSelector) {
      Array.prototype.forEach.call(root.querySelectorAll(opts.mediaSelector), function (el) {
        el.classList.add('slide-up-media');
        items.push(el);
      });
    }

    if (opts.textSelector) {
      Array.prototype.forEach.call(root.querySelectorAll(opts.textSelector), function (el) {
        var units = unit === 'chars' ? splitChars(el) : splitWords(el);
        units.forEach(function (u) {
          items.push(u);
        });
      });
    }

    if (!items.length) return;

    function showFinal() {
      items.forEach(function (el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
        el.style.transition = '';
        el.style.transitionDelay = '';
      });
      root.classList.add('is-words-in');
      if (typeof opts.onTimeline === 'function') opts.onTimeline(0);
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      showFinal();
      return;
    }

    items.forEach(function (el) {
      el.style.transition = 'none';
      el.style.opacity = '0';
      el.style.transform = from;
    });

    function play() {
      void root.offsetHeight;
      var totalMs = unitDuration;

      if (opts.parallelLines) {
        var lines = groupByVisualLine(items);
        var maxInLine = 1;
        lines.forEach(function (line) {
          if (line.length > maxInLine) maxInLine = line.length;
          line.forEach(function (el, i) {
            el.style.transition = transition;
            el.style.transitionDelay = lineUnitDelayMs(i, lineStep) + 'ms';
            el.style.opacity = '1';
            el.style.transform = to;
          });
        });
        totalMs = lineUnitDelayMs(Math.max(0, maxInLine - 1), lineStep) + unitDuration;
        root.classList.add('is-words-in');
        if (typeof opts.onTimeline === 'function') opts.onTimeline(totalMs);
        window.setTimeout(function () {
          items.forEach(function (el) {
            el.style.transition = '';
            el.style.transitionDelay = '';
          });
        }, totalMs + 80);
        return;
      }

      var n = items.length;
      items.forEach(function (el, i) {
        el.style.transition = transition;
        el.style.transitionDelay = wordStaggerDelayMs(i, n) + 'ms';
        el.style.opacity = '1';
        el.style.transform = to;
      });
      totalMs = wordStaggerDelayMs(n - 1, n) + unitDuration;
      root.classList.add('is-words-in');
      if (typeof opts.onTimeline === 'function') opts.onTimeline(totalMs);

      window.setTimeout(function () {
        items.forEach(function (el) {
          el.style.transition = '';
          el.style.transitionDelay = '';
        });
      }, totalMs + 80);
    }

    function startPlay() {
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          window.requestAnimationFrame(play);
        });
        return;
      }
      window.requestAnimationFrame(play);
    }

    if (opts.immediate || typeof IntersectionObserver === 'undefined') {
      startPlay();
      return;
    }

    var done = false;
    var io = new IntersectionObserver(
      function (entries) {
        if (done) return;
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          done = true;
          io.disconnect();
          startPlay();
          break;
        }
      },
      {
        threshold: 0.2,
        rootMargin: '0px 0px -10% 0px'
      }
    );
    io.observe(root);
  }

  function boot() {
    /* Der Home-Teaser ist Teil des gemeinsamen Opacity-Staggers. */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
